import { TabPanel } from '../shared/Tabs';
import Tabs from './tabs';

export { TabPanel, Tabs };
